import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseMaintenanceEstablishmentChoiceAuctionEntryUnfollowProps {
  auctionEntryId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceEstablishmentChoiceAuctionEntryUnfollow = ({
  auctionEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryUnfollowProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceAuctionEntryUnfollow', auctionEntryId],
    mutationFn: () =>
      privateAxios.post(`/maintenance/establishment_choice/auction_entries/${auctionEntryId}/unfollow`),
    ...options,
  })
}
